import { ProfessionalContractTypeKeyString } from 'InstitutionalManagement/types'

export const PROFESSIONAL_CONTRACT_TYPE_FIELDS_INITIAL_VALUES: ProfessionalContractTypeKeyString = {
  id: '',
  name: '',
  description: '',
  status: '',
}
